import api from './api';

const feedbackService = {
  // Public/authenticated: create feedback (backend can attach user if token exists)
  createFeedback: async (data) => {
    const response = await api.post('/feedback', data);
    return response.data;
  },

  // Authenticated user: list my feedback
  getMyFeedback: async (params) => {
    const response = await api.get('/feedback/my', { params });
    return response.data;
  },

  // Authenticated user: delete my feedback
  deleteMyFeedback: async (id) => {
    const response = await api.delete(`/feedback/${id}`);
    return response.data;
  },

  // Admin: list feedback (optionally filter by user/status)
  getAdminFeedback: async (params) => {
    const response = await api.get('/admin/feedback', { params });
    return response.data;
  },

  // Admin: update feedback status
  updateFeedbackStatus: async (id, status) => {
    const response = await api.patch(`/admin/feedback/${id}/status`, { status });
    return response.data;
  },
};

export default feedbackService;

